import React from "react";
import Box from "@mui/material/Box";
import { WordWheelAppearanceProvider } from "../context/WordWheelAppearanceContext";

/** Full-viewport shell for word wheel screenshot routes (no app chrome). */
export default function WordWheelScreenshotLayout({ children }) {
    return (
        <WordWheelAppearanceProvider>
            <Box
                sx={{
                    minHeight: "100dvh",
                    width: "100%",
                    boxSizing: "border-box",
                    overflowX: "hidden",
                }}
            >
                {children}
            </Box>
        </WordWheelAppearanceProvider>
    );
}
